import React from "react";
import { Icon } from "antd";
import { StatusRender } from "../Assets/StatusRender";
import { saveRedirectPath } from "../../util/Auth";
import boldWords from "../Assets/boldWords";
import boldMain from "../Assets/boldMain";

const EquipmentTable = props => {
  const {
    history,
    equipmentList,
    pageLength,
    equipmentLoader,
    conditions,
    setEquipmentDetails,
    wildWords,
    sort,
    sortDir,
    setStateSort,
    setStateSortDirection
  } = props;

  const sortIcon = field =>
    sort === field &&
    (sortDir === "Asc" ? <Icon type="arrow-down" /> : <Icon type="arrow-up" />);

  const handleClickHeader = field => {
    if (field !== sort) {
      setStateSort(field);
      setStateSortDirection("Asc");
      return;
    } else if (sortDir === "Asc") {
      setStateSortDirection("Desc");
      return;
    }
    setStateSort("rank");
    setStateSortDirection("Desc");
  };

  const table = () => {
    return (
      <div className="EfTableContainer">
        <table className="EFtable">
          <thead>
            <tr>
              <th
                className="EFtableHeader"
                onClick={() => handleClickHeader("fldDesc")}
              >
                Description {sortIcon("fldDesc")}
              </th>
              <th className="EFtableHeader">Status</th>
              <th
                className="EFtableHeader"
                onClick={() => handleClickHeader("branchCode")}
              >
                Branch {sortIcon("branchCode")}
              </th>
              <th
                className="EFtableHeader"
                onClick={() => handleClickHeader("fleetNo")}
              >
                Product {sortIcon("fleetNo")}
              </th>
              <th
                className="EFtableHeader"
                onClick={() => handleClickHeader("type")}
              >
                Category {sortIcon("type")}
              </th>
              <th
                className="EFtableHeader"
                onClick={() => handleClickHeader("regionCode")}
              >
                Region {sortIcon("regionCode")}
              </th>
            </tr>
          </thead>
          <tbody>
            {equipmentLoader
              ? Array.apply(null, { length: pageLength }).map((e, i) => (
                  <tr className="tableLoadCell" key={`loader${i}`}>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                ))
              : equipmentList.slice(0, pageLength).map((elem, index) => (
                  <tr
                    key={`EFTable${index}`}
                    onClick={() => {
                      setEquipmentDetails(elem);
                      saveRedirectPath(`/${window.location.search}`);
                      history.push(
                        `/equipment/${elem.fleetNo}/${
                          elem.fleetBranchId
                        }/${elem.branchCode.substring(0, 4)}`
                      );
                    }}
                  >
                    <td
                      dangerouslySetInnerHTML={boldWords(
                        elem.fldDesc,
                        wildWords
                      )}
                    ></td>
                    <td>
                      <StatusRender
                        terminated={elem.terminated}
                        reserved={elem.reserved}
                        qtyAvail={elem.qtyAvail}
                        available={elem.available}
                        catType={elem.catType}
                        qtyOnHire={elem.qtyOnHire}
                        condition={elem.condition}
                        conditions={conditions}
                      />
                    </td>
                    <td
                      dangerouslySetInnerHTML={boldMain(
                        elem.description,
                        elem.branchCode,
                        elem.isMain
                      )}
                    ></td>
                    <td
                      dangerouslySetInnerHTML={boldWords(
                        elem.fleetNo,
                        wildWords,
                        true
                      )}
                    ></td>
                    <td>
                      {elem.type} - {elem.catType}
                    </td>
                    <td>{elem.regionCode}</td>
                  </tr>
                ))}
          </tbody>
        </table>
      </div>
    );
  };

  return table();
};

export default EquipmentTable;
